import React from "react"

// Tùy biến KHCN: minh hoạ nền hero khi chưa có ảnh danh lam thật, và lớp phủ công nghệ có animation.
// Ba phong cảnh cách điệu về Hà Tĩnh: "city" (TP Hà Tĩnh, cầu dây văng), "sea" (biển Thiên Cầm,
// cảng Vũng Áng, hải đăng) và "mountain" (Đèo Ngang – Hoành Sơn Quan, đồi núi, turbine gió).
// Toàn bộ chuyển động là CSS (HeroBanner.scss), tắt khi prefers-reduced-motion.

export type HeroVariant = "city" | "sea" | "mountain"

const SKY: Record<HeroVariant, [string, string, string]> = {
  city: ["#071a4a", "#0e4cb5", "#38bdf8"],
  sea: ["#0a2e7a", "#1d6fe8", "#a5e3ff"],
  mountain: ["#071a4a", "#0e3f9f", "#f7c948"],
}

const Clouds = () => (
  <g className="kh-scene__clouds" fill="#ffffff" opacity="0.16">
    <g className="kh-scene__cloud kh-scene__cloud--1">
      <ellipse cx="260" cy="120" rx="120" ry="26" />
      <ellipse cx="320" cy="104" rx="70" ry="30" />
    </g>
    <g className="kh-scene__cloud kh-scene__cloud--2">
      <ellipse cx="760" cy="80" rx="150" ry="24" />
      <ellipse cx="830" cy="66" rx="80" ry="28" />
    </g>
    <g className="kh-scene__cloud kh-scene__cloud--3">
      <ellipse cx="1300" cy="150" rx="110" ry="22" />
    </g>
  </g>
)

const Birds = () => (
  <g className="kh-scene__birds" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" opacity="0.7">
    <path className="kh-scene__bird" d="M560 190q12-14 24 0M584 190q12-14 24 0" />
    <path className="kh-scene__bird kh-scene__bird--2" d="M640 230q10-12 20 0M660 230q10-12 20 0" />
    <path className="kh-scene__bird kh-scene__bird--3" d="M610 260q9-10 18 0M628 260q9-10 18 0" />
  </g>
)

const Turbine = ({ x, y, scale = 1 }: { x: number; y: number; scale?: number }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`} fill="#e6edf7">
    <path d="M-3 0h6l4 150h-14z" opacity="0.9" />
    <g className="kh-scene__rotor" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" fill="none">
      <path d="M0 0v-62M0 0l54 31M0 0l-54 31" />
    </g>
    <circle r="6" fill="#ffffff" />
  </g>
)

const CityScene = () => (
  <>
    {/* núi xa */}
    <path d="M0 420L140 350L260 400L420 330L560 400L700 360L820 410L1600 400V640H0Z" fill="#0a2e7a" opacity="0.55" />
    {/* mặt nước */}
    <rect x="0" y="470" width="1600" height="170" fill="#0e3f9f" opacity="0.9" />
    <path
      className="kh-scene__wave"
      d="M0 500c100-18 200-18 300 0s200 18 300 0 200-18 300 0 200 18 300 0 200-18 300 0 200 18 300 0v140H0z"
      fill="#1d6fe8"
      opacity="0.55"
    />
    {/* cầu dây văng */}
    <g stroke="#071a4a" strokeWidth="4" strokeLinecap="round">
      <line x1="120" y1="470" x2="1080" y2="470" strokeWidth="10" />
      <line x1="430" y1="470" x2="430" y2="250" strokeWidth="14" />
      <line x1="770" y1="470" x2="770" y2="250" strokeWidth="14" />
      {[-260, -200, -140, -80, 80, 140, 200, 260].map((dx) => (
        <React.Fragment key={dx}>
          <line x1="430" y1="258" x2={430 + dx} y2="466" strokeWidth="2" opacity="0.9" />
          <line x1="770" y1="258" x2={770 + dx} y2="466" strokeWidth="2" opacity="0.9" />
        </React.Fragment>
      ))}
    </g>
    <g className="kh-scene__lights" fill="#f7c948">
      {[180, 300, 430, 560, 690, 770, 900, 1020].map((x, i) => (
        <circle key={x} cx={x} cy="462" r="3.5" className={`kh-scene__blink kh-scene__blink--${(i % 3) + 1}`} />
      ))}
    </g>
    {/* thành phố */}
    <g fill="#071a4a">
      {[
        [1060, 380, 60, 90],
        [1130, 330, 70, 140],
        [1210, 360, 50, 110],
        [1270, 290, 80, 180],
        [1360, 340, 60, 130],
        [1430, 300, 70, 170],
        [1510, 370, 90, 100],
      ].map(([x, y, w, h]) => (
        <rect key={x} x={x} y={y} width={w} height={h} rx="3" />
      ))}
    </g>
    <g fill="#ffe08a" opacity="0.9">
      {[
        [1145, 350],
        [1165, 380],
        [1290, 320],
        [1310, 350],
        [1330, 380],
        [1450, 330],
        [1470, 360],
        [1380, 360],
        [1530, 390],
      ].map(([x, y], i) => (
        <rect key={`${x}-${y}`} x={x} y={y} width="8" height="10" className={`kh-scene__blink kh-scene__blink--${(i % 3) + 1}`} />
      ))}
    </g>
    {/* flycam */}
    <g className="kh-scene__drone" fill="#ffffff">
      <rect x="-14" y="-3" width="28" height="6" rx="3" />
      <circle cx="-16" cy="-5" r="5" opacity="0.8" />
      <circle cx="16" cy="-5" r="5" opacity="0.8" />
      <circle cx="0" cy="6" r="3" fill="#f7c948" className="kh-scene__blink kh-scene__blink--2" />
    </g>
    <Birds />
  </>
)

const SeaScene = () => (
  <>
    <path d="M0 400L220 330L360 390L520 340L700 400L1600 380V640H0Z" fill="#0a2e7a" opacity="0.5" />
    <rect x="0" y="420" width="1600" height="220" fill="#0e4cb5" opacity="0.95" />
    <path
      className="kh-scene__wave"
      d="M0 450c100-20 200-20 300 0s200 20 300 0 200-20 300 0 200 20 300 0 200-20 300 0 200 20 300 0v190H0z"
      fill="#1d6fe8"
      opacity="0.7"
    />
    <path
      className="kh-scene__wave kh-scene__wave--2"
      d="M0 520c120-16 240-16 360 0s240 16 360 0 240-16 360 0 240 16 360 0 240-16 360 0v120H0z"
      fill="#38bdf8"
      opacity="0.28"
    />
    {/* ghềnh đá */}
    <path d="M1180 470l60-40 70 20 40-30 90 40 60-10 100 30v70H1140z" fill="#071a4a" />
    {/* hải đăng */}
    <g transform="translate(1330 300)">
      <path d="M-14 150h28l-8-150h-12z" fill="#e6edf7" />
      <rect x="-11" y="-22" width="22" height="24" rx="3" fill="#0a2e7a" />
      <rect x="-8" y="-16" width="16" height="12" fill="#ffe08a" />
      <path className="kh-scene__beam" d="M0 -10L520 -90V70Z" fill="#ffe08a" opacity="0.25" />
    </g>
    {/* tàu */}
    <g className="kh-scene__ship" fill="#071a4a">
      <path d="M0 0h140l-18 24H18z" />
      <rect x="40" y="-30" width="60" height="30" rx="2" />
      <rect x="86" y="-48" width="10" height="20" />
    </g>
    <g className="kh-scene__ship kh-scene__ship--2" fill="#0a2e7a" opacity="0.8">
      <path d="M0 0h90l-12 16H12z" />
      <rect x="30" y="-18" width="30" height="18" rx="2" />
    </g>
    <Birds />
  </>
)

const MountainScene = () => (
  <>
    <path d="M0 380L180 260L330 340L470 230L640 350L800 280L960 380L1120 300L1300 400L1600 330V640H0Z" fill="#0e3f9f" opacity="0.55" />
    <path d="M0 470L160 400L300 450L450 370L600 460L760 410L900 470L1080 420L1240 480L1400 430L1600 470V640H0Z" fill="#0a2e7a" opacity="0.9" />
    <path d="M0 540L200 490L380 530L560 480L760 540L940 500L1120 550L1300 510L1600 540V640H0Z" fill="#071a4a" />
    {/* Hoành Sơn Quan: cổng đèo */}
    <g transform="translate(700 360)" fill="#071a4a">
      <rect x="-70" y="-10" width="140" height="16" rx="3" />
      <rect x="-56" y="6" width="18" height="64" />
      <rect x="38" y="6" width="18" height="64" />
      <path d="M-56 70h112v10H-56z" />
      <path d="M-30 70a30 34 0 0 1 60 0z" fill="#0e3f9f" />
    </g>
    <Turbine x={230} y={360} scale={0.9} />
    <Turbine x={420} y={330} />
    <Turbine x={1180} y={370} scale={0.8} />
    <Birds />
  </>
)

export const HeroLandscape = ({ variant }: { variant: HeroVariant }) => {
  const [top, mid, bottom] = SKY[variant]
  const skyId = `khSky-${variant}`
  const sun = variant === "mountain" ? { x: 1240, y: 190, r: 70 } : { x: 1180, y: 140, r: 56 }
  return (
    <svg className={`kh-scene kh-scene--${variant}`} viewBox="0 0 1600 640" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={skyId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={top} />
          <stop offset="0.6" stopColor={mid} />
          <stop offset="1" stopColor={bottom} />
        </linearGradient>
        <radialGradient id="khSun" cx="50%" cy="50%" r="50%">
          <stop offset="0" stopColor="#fff6cf" />
          <stop offset="0.45" stopColor="#ffe08a" stopOpacity="0.9" />
          <stop offset="1" stopColor="#f7c948" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="1600" height="640" fill={`url(#${skyId})`} />
      <circle className="kh-scene__sun" cx={sun.x} cy={sun.y} r={sun.r * 2.6} fill="url(#khSun)" />
      <Clouds />
      {variant === "city" && <CityScene />}
      {variant === "sea" && <SeaScene />}
      {variant === "mountain" && <MountainScene />}
    </svg>
  )
}

// ---------- Lớp phủ công nghệ: mạng lưới nút phát sáng, thẻ icon lơ lửng, hạt sáng bay lên ----------

const NODES: [number, number][] = [
  [980, 120],
  [1120, 90],
  [1260, 160],
  [1400, 110],
  [1080, 240],
  [1240, 300],
  [1380, 250],
  [1500, 320],
  [1160, 400],
  [1320, 430],
]
const EDGES: [number, number][] = [
  [0, 1],
  [1, 2],
  [2, 3],
  [0, 4],
  [4, 5],
  [5, 6],
  [6, 7],
  [4, 8],
  [8, 9],
  [5, 9],
  [2, 6],
]
const SPARKS = [1020, 1110, 1190, 1275, 1350, 1440, 1520, 1060, 1230, 1410]

const FloatCard = ({ x, y, index, children }: { x: number; y: number; index: number; children: React.ReactNode }) => (
  <g className={`kh-tech__float kh-tech__float--${index}`} transform={`translate(${x} ${y})`}>
    <rect x="-26" y="-26" width="52" height="52" rx="14" fill="#ffffff" fillOpacity="0.12" stroke="#ffffff" strokeOpacity="0.35" />
    <g fill="none" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </g>
  </g>
)

export const HeroTech = () => (
  <svg className="kh-tech" viewBox="0 0 1600 640" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="khNode" cx="50%" cy="50%" r="50%">
        <stop offset="0" stopColor="#ffffff" />
        <stop offset="0.4" stopColor="#a5e3ff" />
        <stop offset="1" stopColor="#38bdf8" stopOpacity="0" />
      </radialGradient>
    </defs>

    <g className="kh-tech__edges" stroke="#a5e3ff" strokeWidth="1.4" strokeOpacity="0.55" strokeDasharray="6 10">
      {EDGES.map(([a, b]) => (
        <line key={`${a}-${b}`} x1={NODES[a][0]} y1={NODES[a][1]} x2={NODES[b][0]} y2={NODES[b][1]} />
      ))}
    </g>
    <g className="kh-tech__nodes">
      {NODES.map(([x, y], i) => (
        <g key={i} className={`kh-tech__node kh-tech__node--${(i % 4) + 1}`} transform={`translate(${x} ${y})`}>
          <circle r="14" fill="url(#khNode)" opacity="0.9" />
          <circle r="3.2" fill="#ffffff" />
        </g>
      ))}
    </g>

    {/* đám mây / dữ liệu */}
    <FloatCard x={1050} y={60} index={1}>
      <path d="M-9 8h17a6 6 0 0 0 1-11.9A8 8 0 0 0-9-2a5 5 0 0 0 0 10z" />
    </FloatCard>
    {/* vi mạch */}
    <FloatCard x={1335} y={62} index={2}>
      <rect x="-9" y="-9" width="18" height="18" rx="3" />
      <rect x="-4" y="-4" width="8" height="8" rx="1" />
      <path d="M-9-4h-5M-9 4h-5M9-4h5M9 4h5M-4-9v-5M4-9v-5M-4 9v5M4 9v5" />
    </FloatCard>
    {/* sóng kết nối */}
    <FloatCard x={1478} y={205} index={3}>
      <path d="M-12-2a17 17 0 0 1 24 0M-7 4a10 10 0 0 1 14 0" />
      <circle cx="0" cy="9" r="1.8" fill="#ffffff" />
    </FloatCard>
    {/* bánh răng */}
    <FloatCard x={1000} y={330} index={4}>
      <circle r="7.5" strokeWidth="5" strokeDasharray="3.2 2.6" />
      <circle r="3" />
    </FloatCard>
    {/* nguyên tử */}
    <FloatCard x={1255} y={478} index={5}>
      <ellipse rx="12" ry="5" />
      <ellipse rx="12" ry="5" transform="rotate(60)" />
      <ellipse rx="12" ry="5" transform="rotate(-60)" />
      <circle r="2.2" fill="#ffe08a" stroke="none" />
    </FloatCard>

    <g className="kh-tech__sparks" fill="#ffe08a">
      {SPARKS.map((x, i) => (
        <circle key={x} cx={x} cy="620" r={i % 3 === 0 ? 2.6 : 1.8} className={`kh-tech__spark kh-tech__spark--${(i % 5) + 1}`} />
      ))}
    </g>
  </svg>
)
